import { EventEmitter } from "events"
import dispatcher from "../dispatcher"
import { IFireStoreAsyncSession } from "../models"
class FirestoreStore extends EventEmitter {
    private asyncSessionId: string
    private authConfig: any
    private asyncSession: IFireStoreAsyncSession
    constructor() {
        super()
        this.setMaxListeners(0)
        this.asyncSessionId = null
        this.authConfig = null
        this.asyncSession = null
    }

    getAsyncSessionId() {
        return this.asyncSessionId
    }

    setAsyncSessionId(asyncSessionId) {
        if (asyncSessionId) {
            this.asyncSessionId = asyncSessionId
        }
        else {
            this.asyncSessionId = null
            this.asyncSession = null
        }
        this.emit("change")
    }

    setAsyncAuthString(authConfig) {
        this.authConfig = authConfig
        this.emit("change")
    }

    getAuthConfig() {
        return this.authConfig
    }

    setAsyncSession(data: IFireStoreAsyncSession) {
        this.asyncSession = data
        this.setAsyncSessionId(data.asyncSessionId)
    }

    getAsyncSession() {
        return this.asyncSession
    }

    handleActions(action) {
        switch (action.type) {
            case "UPDATE_ASYNC_SESSION": {
                this.setAsyncSession(action.data)
                break
            }
            case "UPDATE_ASYNC_SESSION_ID": {
                this.setAsyncSessionId(action.data)
                break
            }
            case "UPDATE_ASYNC_AUTH": {
                this.setAsyncAuthString(action.data)
                break
            }
        }
    }
}

const firestoreStore = new FirestoreStore()
dispatcher.register(firestoreStore.handleActions.bind(firestoreStore))

export default firestoreStore
